import { ControlIcons } from 'owa-control-icons';
import loc, { format } from 'owa-localize';
import { undoAction } from 'owa-locstrings/lib/strings/undoaction.locstring.json';
import { getListViewNotificationDimensions } from 'owa-mail-layout';
import * as undoActions from 'owa-mail-undo';
import { lazyShowNotification, NotificationBarCallbackReason } from 'owa-notification-bar';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import {
    deleteItemSucceededNotification,
    deleteItemsSucceededNotification,
} from './showNotificationOnDelete.locstring.json';

/**
 * show notification on delete
 * @param numberOfItems acted on for the delete action
 */
export default function showNotificationOnDelete(numberOfItems: number, allowUndo: boolean) {
    if (!getUserConfiguration().UserOptions.ShowNotificationBar) {
        return;
    }

    const notificationText =
        numberOfItems === 1
            ? loc(deleteItemSucceededNotification)
            : format(loc(deleteItemsSucceededNotification), numberOfItems);
    const notificationDimensions = getListViewNotificationDimensions();

    lazyShowNotification.importAndExecute(
        'deleteNotification',
        'MailModuleNotificationBarHost',
        notificationText,
        {
            icon: ControlIcons.Delete,
            primaryActionText: allowUndo ? loc(undoAction) : null,
            allowClear: true,
            // Want 12 px of padding on either side of the notificaiton bar
            minWidth: notificationDimensions.minWidth,
            maxWidth: notificationDimensions.maxWidth,
            notificationCallback: reason => {
                if (reason === NotificationBarCallbackReason.PrimaryActionClicked) {
                    undoActions.lazyUndo.importAndExecute('NotificationBar');
                }
            },
        }
    );
}
